import React from "react"

export const PhoneComponents = (props: { tel: string, showWhatsApp?: boolean, whatsAppText?: string }) => {
    const clearedPhone = props.tel
        .replace(" ", "")
        .replace(/[^0-9]/g, "");

    const onWhatsAppClick = (cell: string) => {
        let waUrl = `https://wa.me/+39${cell}`;
        if (props.whatsAppText)
            waUrl += `&text=${encodeURIComponent(props.whatsAppText)}`
        window.open(waUrl, '_blank')
    }

    return props.tel && <span className="d-flex align-items-center">
        <a type="button" href={`tel:+39${clearedPhone}`} className="btn btn-link p-0" >
            <i className="fas fa-phone me-1" />
        </a>
        {props.showWhatsApp && <a type="button" className="btn btn-link p-0 me-1"
            onClick={() => onWhatsAppClick(clearedPhone)}>
            <i className="fab fa-whatsapp text-success me-1" />
        </a>}
        <span>{props.tel}</span>
    </span > || null;
}

export const TelAnchor = (props: { tel: string }) => {
    return <a ><i className="fas fa-phone me-1" /> {props.tel}</a>
}